import { ChangeDetectionStrategy, Component, computed, input, Signal, signal } from '@angular/core';

import { DesignSystemModule } from '@compeople-shared/design-system-angular';
import { Subject } from 'rxjs';

import { ComponentsModule } from '@components/components.module';
import { SpaButtonComponent } from '@components/spa-button/spa-button.component';

import { ModalComponent } from '../../notification.service';

export interface ModalButton {
  dataTestID?: string;
  disabled?: Signal<boolean>;
  icon?: string;
  iconPlacement?: (typeof SpaButtonComponent)['prototype']['iconPlacement'];
  label?: string;
  shape?: (typeof SpaButtonComponent)['prototype']['shape'];
  action?: () => void | Promise<void>;
}

@Component({
  selector: 'spa-notification-modal',
  imports: [DesignSystemModule, ComponentsModule],
  styleUrls: ['./notification-modal.component.scss'],
  template: `<dx-modal
    data-testid="delete_configuration_modal"
    height="content"
    [label]="titleString()"
    [visible]="visible()"
    (modalClosed)="onCloseModal()"
  >
    <div class="content-container" slot="content">
      @for (message of normalizedMessage(); track message) {
        <dx-text>{{ message }}</dx-text>
      }
    </div>
    <div class="button-container" slot="custom-actions">
      @for (button of buttons(); track button) {
        <spa-button
          [attr.data-testid]="button.dataTestID"
          [disabled]="button.disabled?.() ?? false"
          [icon]="button.icon ?? ''"
          [label]="button.label ?? ''"
          [shape]="button.shape ?? 'primary'"
          (click)="button.action?.(); this.closeModal()"
        ></spa-button>
      }
    </div>
  </dx-modal>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationModalComponent implements ModalComponent {
  titleString = input<string | undefined>(undefined);
  messages = input<string | string[] | undefined>(undefined);
  buttons = input<ModalButton[] | undefined>(undefined);

  normalizedMessage = computed(() => {
    if (typeof this.messages() === 'string') {
      return [this.messages()];
    }
    if (Array.isArray(this.messages())) {
      return this.messages();
    }
    return [];
  });

  visible = signal(true);

  close = new Subject<void>();

  onCloseModal() {
    this.close.next();
    this.close.complete();
  }

  closeModal() {
    this.visible.set(false);
    setTimeout(() => {
      this.onCloseModal();
    }, 500);
  }
}
